/**
 * @generated SignedSource<<d545ea2bcf9884a82267d230b75f54cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MondayGroupSelectorQuery$variables = {
  boardId: string;
};
export type MondayGroupSelectorQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly monday: {
        readonly groups: ReadonlyArray<{
          readonly externalId: string;
          readonly id: string;
          readonly name: string;
        }>;
      } | null;
    };
  };
};
export type MondayGroupSelectorQuery = {
  response: MondayGroupSelectorQuery$data;
  variables: MondayGroupSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "boardId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "boardId",
      "variableName": "boardId"
    }
  ],
  "concreteType": "MondayGroupNode",
  "kind": "LinkedField",
  "name": "groups",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MondayGroupSelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MondayUserNode",
                "kind": "LinkedField",
                "name": "monday",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MondayGroupSelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MondayUserNode",
                "kind": "LinkedField",
                "name": "monday",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1382ee71359fb6bcda483d506f9c8657",
    "id": null,
    "metadata": {},
    "name": "MondayGroupSelectorQuery",
    "operationKind": "query",
    "text": "query MondayGroupSelectorQuery(\n  $boardId: String!\n) {\n  viewer {\n    integrations {\n      monday {\n        groups(boardId: $boardId) {\n          id\n          name\n          externalId\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "030dddd819747686ba2ce37bc67a1935";

export default node;
